import React from 'react'

import PropTypes from 'prop-types'

import NavigationLastAdsSearchesItem from './navigation-last-ads-searches-link.js'

const NavigationLastAdsSearchesContent = ({lastAdsSearches, className}) => {
  return (
    <div className={`${className}-list`}>
      {lastAdsSearches.map((search, index) => (
        <NavigationLastAdsSearchesItem {...search} key={index} className={className} />
      ))}
    </div>
  )
}

NavigationLastAdsSearchesContent.displayName = 'NavigationLastAdsSearchesContent'

NavigationLastAdsSearchesContent.propTypes = {
  lastAdsSearches: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ),
  className: PropTypes.string
}

const MemoNavigationLastAdsSearchesContent = React.memo(NavigationLastAdsSearchesContent)

export default MemoNavigationLastAdsSearchesContent
